import { getGameState, saveGameState } from 'a/actions/persistStateActions';
import { PRODUCT_LECTURA } from 'root/lib/constants';
import { GAME_ID, GAME_ID_ES, SAVED_DATA_VERSION } from '../data/constants';

export const loadSkillScanData = () => async (dispatch, getState) => {
  const { appSessionReducer: { product } } = getState();
  const gameStateBucket = product === PRODUCT_LECTURA ? GAME_ID_ES : GAME_ID;
  await dispatch(getGameState(gameStateBucket));
};

export const saveSkillScanProgress = (data, product) => (dispatch) => {
  const versionedData = { ...data, version: SAVED_DATA_VERSION };
  const gameStateBucket = product === PRODUCT_LECTURA ? GAME_ID_ES : GAME_ID;
  try {
    dispatch(saveGameState(gameStateBucket, versionedData));
  } catch (e) {
    console.error(`There is a problem with the intermediate save object of skill scan: ${e.message}`);
  }
};
